// Carte.js
import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { Paper, Typography, Box } from "@mui/material";
import { motion } from "framer-motion";

// Fix des icônes Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
});

const Carte = ({ latitude, longitude }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Paper
  elevation={6}
  sx={{
    p: 2,
    borderRadius: 3,
    backgroundColor: "#f5f5f5",
    position: "relative",  // Ajoute un positionnement relatif
    zIndex: 1,             // Assure-toi que la carte est en dessous des autres éléments
  }}
>

        <Box
          sx={{
            height: "350px",
            borderRadius: 2,
            overflow: "hidden",
            border: "1px solid #ccc",
          }}
        >
          <MapContainer
            center={[latitude, longitude]}
            zoom={15} // Augmente le zoom pour voir de plus près
            style={{ height: "100%", width: "100%" }}
            >

            <TileLayer
              url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={[latitude, longitude]}>
              <Popup>Vous êtes ici 📍</Popup>
            </Marker>
          </MapContainer>
        </Box>
      </Paper>
    </motion.div>
  );
};

export default Carte;



